export enum ModelEventConstants {
    PLAYER_JUMP = 'PLAYER_JUMP',
    PLAYER_DOUBLE_JUMP = 'PLAYER_DOUBLE_JUMP',
    COLLISION_STOPPER = 'COLLISION_STOPPER',
    ADD_COLLISION_SUBJECT = 'ADD_COLLISION_SUBJECT',
    COLLISION_OUTFIT = 'COLLISION_OUTFIT'
}